// extracted by mini-css-extract-plugin
export default {"wrapper":"TextGrouping_wrapper__kf2+8","title":"TextGrouping_title__HzGbQ","value":"TextGrouping_value__PQT2T"};